if (!customElements.get("td-shipping-bar")) {
    class TDShippingBar extends HTMLElement {
        constructor() {
            super();
            this.PROGRESS_BAR_CLASS = '.td-shipping-bar__bar-progress';
            this.PROGRESS_MESSAGE_CLASS = '.td-shipping-bar__message';
            this.PROGRESS_CONTAINER_CLASS = '.td-shipping-bar__container';

            this.progressBar = this.querySelector(this.PROGRESS_BAR_CLASS);
            this.progressBarContainer = this.querySelector(this.PROGRESS_CONTAINER_CLASS);
            this.progressMessage = this.querySelector(this.PROGRESS_MESSAGE_CLASS);
        }
    
        connectedCallback() {
            document.addEventListener('ajaxProduct:added', () => {
                this.cartTotal();
            })
            document.addEventListener('cart:updated', () => {
                this.cartTotal();
            })
        }

        updateUI(detail) {
            let minimum = this.progressBarContainer.dataset.shippingMin;
            console.log(minimum, detail, this.progressBar)
            if (this.progressBar && detail && minimum) {
                const progressTotalPercent = ((detail / minimum) * 100);
                const progressTotalRemaning = (minimum - detail);
                if (progressTotalPercent >= 100) {
                    this.progressBar.style.width = "100%";
                    this.progressMessage.innerHTML = `<strong>Free shipping</strong> included for your order`;
                } else {
                    this.progressBar.style.width = `calc(${progressTotalPercent}%)`;
                    this.progressMessage.innerHTML = `You're $${progressTotalRemaning} away from <strong>free shipping</strong>`;
                }
            }   
        }

        // GET CART QUANTITY AJAX/LOGIC
        async cartTotal() {
            try {
                const response = await fetch(`${window.location.origin}/cart.js`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }
                });
        
                if (response.status === 200) {
                    const {total_price} = await response.json();

                    if (total_price > 0) {
                        let priceInDollars = total_price / 100;
                        this.updateUI(priceInDollars);
                    }
                }

            } catch (err) {
                console.log(err);
            }
        }
    }

    customElements.define("td-shipping-bar", TDShippingBar);
}